import React from 'react'
import { renderReact } from 'hypernova-react'

// I18n
import { IntlProvider, addLocaleData } from 'react-intl'
import en from 'react-intl/locale-data/en'
import ru from 'react-intl/locale-data/ru'
import zh from 'react-intl/locale-data/zh'
import ja from 'react-intl/locale-data/ja'
import localeData from './locales/data'

// Components
import ForgotPasswordApp from './forgot_password/app'

addLocaleData([...en, ...ru, ...zh, ...ja])

const ForgotPassword = (props) => {
  const { intlLocale } = props
  const messages = localeData[intlLocale]

  return (
    <IntlProvider locale={intlLocale} messages={messages}>
      <ForgotPasswordApp messages={messages} {...props} />
    </IntlProvider>
  )
}

export default renderReact('application/forgot_password', ForgotPassword)



// WEBPACK FOOTER //
// ./app/javascript/components/application/forgot_password.js